/**
 * How much of a video one clip content may cover: credits are the only cap.
 *
 * One credit covers one minute of the section (`compute_required_credits_for_section` in
 * backend/altar/providers/billing.py), and the backend refuses a section the balance cannot pay for.
 */

/** Credits on the Free plan; what a signed-out visitor can expect to spend. */
export const FREE_PLAN_CREDITS = 60

/**
 * The longest section the user can afford, in seconds. Signed-out visitors are measured against the
 * Free allowance. With no credits left there is nothing to cap against: the submit hits the paywall.
 */
export function sectionCapSeconds(credits: number | null): number {
  if (credits === null) return FREE_PLAN_CREDITS * 60
  return credits > 0 ? Math.floor(credits) * 60 : Infinity
}

/** Keeps a [start, end] section within `maxSeconds`: the thumb that did not move gives way. */
export function clampSection(
  next: [number, number],
  previous: [number, number],
  maxSeconds: number,
): [number, number] {
  const [start, end] = next
  if (end - start <= maxSeconds) return next
  return start !== previous[0] ? [start, start + maxSeconds] : [end - maxSeconds, end]
}
